import DpsProductGroup from './DpsProductGroup';

export default DpsProductGroup;
